import enGB from './snippet/en-GB.json';
import deDE from './snippet/de-DE.json';

/**
 * This module intentionally has no page component of its own. Its single
 * route exists only so the menu entry below has something to navigate to —
 * that route immediately redirects into Shopware's own generic plugin
 * config page (the same "sw.extension.config" route the Extensions list
 * already links to), passing this plugin's technical name as the
 * "namespace" param. That's a real, native Vue Router redirect, not a
 * hand-rolled reimplementation of the config page — so it keeps working
 * across Shopware versions without this plugin needing to know anything
 * about how that page renders.
 */
Shopware.Module.register('sellops-sticky-cart-config', {
    type: 'plugin',
    name: 'SellopsStickyCart',
    title: 'sellops-sticky-cart.general.mainMenuItemGeneral',
    description: 'sellops-sticky-cart.general.descriptionTextModule',
    color: '#ff6600',
    icon: 'regular-shopping-bag',

    snippets: {
        'en-GB': enGB,
        'de-DE': deDE,
    },

    routes: {
        index: {
            path: 'index',
            redirect: {
                name: 'sw.extension.config',
                params: {
                    namespace: 'SellopsStickyCart',
                },
            },
            meta: {
                privilege: 'system.plugin_maintain',
            },
        },
    },

    navigation: [
        {
            id: 'sellops-sticky-cart-config',
            label: 'sellops-sticky-cart.general.mainMenuItemGeneral',
            color: '#ff6600',
            icon: 'regular-shopping-bag',
            path: 'sellops.sticky.cart.config.index',
            parent: 'sw-marketing',
            position: 100,
            privilege: 'system.plugin_maintain',
        },
    ],
});
